import React, { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import axios from "axios";
import "./PaymentPage.css";
import { BaseUrl } from "../../App";
import { toast } from "react-toastify";
import Swal from "sweetalert2";
import BuyerServicesUrl from "../../BuyerServicesUrl";


export default function PaymentPage() {
  const navigate = useNavigate();
  const location = useLocation();
  const token = localStorage.getItem("token");

 const cartId =
  location.state?.cartId || localStorage.getItem("cartId");

  const [method, setMethod] = useState("cash");

  const [form, setForm] = useState({
    name: "",
    account_number: "",
    cvv: "",
    expair_date: "",
  });

  const [errors, setErrors] = useState({});

  const payNow = async () => {
    if (!cartId) {
      toast.error("السلة غير متاحة ❌");
      return;
    }

    const payload = {
      cart_id: cartId,
      payment_methode: method,
       source: "web"
    };

    if (method === "visa") {
      let newErrors = {};

      if (!form.name.trim()) {
        newErrors.name = "من فضلك أدخل اسم صاحب البطاقة";
      }

      if (!/^\d{14}$/.test(form.account_number)) {
        newErrors.account_number = "Please input a valid number";
      }

      if (!/^\d{3}$/.test(form.cvv)) {
        newErrors.cvv = "Please input a valid CVV";
      }

      if (!/^(0[1-9]|1[0-2])\/\d{2}$/.test(form.expair_date)) {
        newErrors.expair_date = "Please input a valid date";
      }

      setErrors(newErrors);

      if (Object.keys(newErrors).length > 0) {
        return;
      }

      Object.assign(payload, form);
    }

try {
  await axios.post(`${BaseUrl}user/send-order`, payload, {
    headers: {
      Authorization: `Bearer ${token}`,
      Accept: "application/json",
    },
  });

  Swal.fire({
    title: "تم الدفع بنجاح 🎉",
    text: "شكراً لطلبك ✔️",
    icon: "success",
    confirmButtonText: "للتأكد من تنفيذ طلبك اضغط هنا",
    showCloseButton: true,
  }).then((result) => {
    if (result.isConfirmed) {
      navigate("/confirmedorders");
    }
  });

} catch (err) {
  console.error(err.response?.data || err);

  Swal.fire({
    title: "فشل الدفع ❌",
    text: "تأكد من البيانات أو حاول طريقة دفع أخرى",
    icon: "error",
    confirmButtonText: "رجوع",
    showCloseButton: true,
  });
}
  };
async function payWithPaymob() {
  try {
    const totalPrice = location.state?.total || 100;

    const cartId =
      location.state?.cartId || localStorage.getItem("cartId");
          localStorage.setItem("cartId", cartId);

 const res = await axios.post(
  `https://ksa.paymob.com/v1/intention`,
  {
    cartId,
    amount: totalPrice,
    // redirection_url: "http://localhost:3000/payment-result"
    redirection_url: "https://tokalnaja.com/#/confirmedorders"
  },
  {
    headers: {
      // Authorization: `Bearer ${token}`,
      Authorization: `Token YOUR_SECRET_KEY`,
    },
  }
);
console.log(res.data);
    const selected = res.data.payment_keys.find(
      (item) => item.integration === 23764
    );

    if (!selected) return;

    window.location.href = `https://ksa.paymob.com/unifiedcheckout/?publicKey=${selected.key}`;
  } catch (err) {
    console.log(err.response?.data);
  }
}
const goToCheckout = async () => {
  try {
    const res = await axios.post(
      BaseUrl + "user/send-order",
      {
        cart_id: cartId,
          payment_methode: "visa",
  source: "web"
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    console.log(" RESPONSE:", res.data); 
    const url = res.data?.data?.checkout_url;

    if (url) {
      window.location.href = url;
    } else {
      console.log("❌ No checkout URL");
    }
  } catch (err) {
    console.log("❌ ERROR:", err.response?.data);
  }
};
  return (
    <div className="payment-page container mb-5 mt-5 pt-5 pb-5">
      <h1 className="payment-title mt-5 pt-5">
        الدفع / <span>العربة</span> / التسوق
      </h1>

      <div className="payment-wrapper">
        {/* ===== Left Box ===== */}
        <div className="order-summary">
          <h3 className="summary-title">محتويات الطلب</h3>
          <div className="summary-row">
            <span>المنتجات</span>
            <span>2</span>
          </div>
          <div className="summary-row">
            <span>المجموع</span>
            <span>230</span>
          </div>
          <div className="summary-row">
            <span>الشحن</span>
            <span>30</span>
          </div>
          <div className="summary-row total">
            <span>الإجمالي</span>
            <span className="total-num">260</span>
          </div>
        </div>

        {/* ===== Right Box ===== */}
        <div className="payment-methods">
          <label className="method-row">
            <span>نقداً</span>
            <input
              type="radio"
              name="pay"
              checked={method === "cash"}
              onChange={() => setMethod("cash")}
            />
          </label>

          <label className="method-row">
            <span>فيزا</span>
            <input
              type="radio"
              name="pay"
              checked={method === "visa"}
              onChange={() => setMethod("visa")}
            />
          </label>

          {method === "visa" && (
            <div className="visa-form">
              <input
                className={errors.account_number ? "error-input" : ""}
                placeholder="رقم البطاقة"
                maxLength={14}
                value={form.account_number}
                onChange={(e) => {
                  setForm({ ...form, account_number: e.target.value });
                  setErrors({ ...errors, account_number: "" });
                }}
              />
              {errors.account_number && (
                <p className="input-error-text">
                  {errors.account_number}
                </p>
              )}

              <div style={{ display: "flex", gap: "10px" }}>
                <div style={{ flex: 1 }}>
                  <input
                    className={errors.cvv ? "error-input" : ""}
                    placeholder="CVV"
                    maxLength={3}
                    value={form.cvv}
                    onChange={(e) => {
                      setForm({ ...form, cvv: e.target.value });
                      setErrors({ ...errors, cvv: "" });
                    }}
                  />
                  {errors.cvv && (
                    <p className="input-error-text">
                      {errors.cvv}
                    </p>
                  )}
                </div>

                <div style={{ flex: 1 }}>
                  <input
                    className={errors.expair_date ? "error-input" : ""}
                    placeholder="تاريخ الانتهاء MM/YY"
                    value={form.expair_date}
                    onChange={(e) => {
                      setForm({ ...form, expair_date: e.target.value });
                      setErrors({ ...errors, expair_date: "" });
                    }}
                  />
                  {errors.expair_date && (
                    <p className="input-error-text">
                      {errors.expair_date}
                    </p>
                  )}
                </div>
              </div>

              <input
                className={errors.name ? "error-input" : ""}
                placeholder="اسم حامل البطاقة"
                value={form.name}
                onChange={(e) => {
                  setForm({ ...form, name: e.target.value });
                  setErrors({ ...errors, name: "" });
                }}
              />
              {errors.name && (
                <p className="input-error-text">
                  {errors.name}
                </p>
              )}
            </div>
          )}

          <button className="pay-btn"
       //  onClick={method === "visa" ? payWithPaymob : payNow}>
         onClick={method === "visa" ? goToCheckout : payNow}> 
            ادفع الآن
          </button>
        </div>
      </div>
    </div>
  );
}